import React, { useEffect, useState, Fragment } from 'react';
import { PropTypes } from 'prop-types';
import { Dialog, IconButton, DialogContent, Typography, Link } from '@material-ui/core';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from 'sharedComponents/Icon';
import useScreen from 'hooks/useScreen';
import { GET_ENUMS } from 'const/router';

import useStyles from './useStyles';

const EmailConfirmation = props => {
  const { onClose } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const { pathname, search } = useLocation();
  const { isMobile } = useScreen();

  const [email, setEmail] = useState(null);
  const [isSuccessStatus, setSuccessStatus] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const data = {
      success: searchParams.get('account_confirmation_success'),
      uid: searchParams.get('uid'),
    };
    setEmail(data.uid);
    setSuccessStatus(data.success);
  }, []);

  return (
    <div>
      <Dialog open onClose={onClose} fullScreen={isMobile} classes={{ paper: classes.paper }}>
        <IconButton className={classes.dialogClose} onClick={onClose}>
          <Icon name="bigClose" />
        </IconButton>
        <DialogContent>
          <div className={classes.content}>
            {isSuccessStatus ? (
              <Fragment>
                <Typography variant="h1">{t('components.EmailConfirmation.success.title')}</Typography>
                <Typography
                  className={classes.message}
                  variant="body1"
                  dangerouslySetInnerHTML={{
                    __html: t('components.EmailConfirmation.success.text', { email }),
                  }}
                />
              </Fragment>
            ) : (
              <Fragment>
                <Typography variant="h1">{t('components.EmailConfirmation.error.title')}</Typography>
                <Typography
                  className={classes.message}
                  variant="body1"
                  dangerouslySetInnerHTML={{
                    __html: t('components.EmailConfirmation.error.text', { email }),
                  }}
                />
              </Fragment>
            )}
            <div className={classes.links}>
              <Link
                to={{ pathname, search: `?popup=${GET_ENUMS.popup.login}` }}
                component={RouterLink}
                className={classes.link}
              >
                {t('components.EmailConfirmation.login')}
              </Link>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

EmailConfirmation.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default EmailConfirmation;



// WEBPACK FOOTER //
// ./src/components/EmailConfirmation/EmailConfirmation.js